module.exports = __webpack_public_path__ + "static/media/general_error_image.0a34c569.svg";